const select = 'id,name,isActive,isPublicProcess,description,startMode';
const common =
  'instancesNamePattern,automaticNumbersCurrentYear,automaticNumbersCurrentMonth,automaticNumbersCurrentDay,lastGeneratedNumber,isNotificationsEnabled,notificationsFrequency,notificationsFrequencyValue,disableSendApprovedRequestMailAtEnd,disableSendRejectedRequestMailAtEnd,isSendErrorNotificationsEnabled,startFrequency,startFrequencyValue,startDate,lastStartDate,isRequestsLimitEnabled,requestsLimit,maxRejectionCount,isDeadlineEnabled,deadlineMeasureUnit,deadlineMeasureValue,isBulkRequestCreationEnabled,isAllowViewWithoutAuthenticatingEnabled,isAllowApprovalWithoutAuthenticatingEnabled,disableRequestCancellation,commentsAccessMode,isShowPercentEnabled,offlineEnabled';

export default {
  paged: {
    select: `${select},isFavorite,isBulkRequestCreationEnabled`,
    notSelectSearch:
      'processGroup,isPublicProcess,startMode,isFavorite,isBulkRequestCreationEnabled',
    expand: {
      processGroup: { select: 'name' },
    },
  },

  detail: {
    select: `${select},${common},created,updated`,
    expand: {
      processGroup: { select: 'id,name' },
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
      percentActionFilters: { select: 'actionId,actionType' },
    },
  },

  edit: {
    select: `${select},${common}`,
    expand: {
      processGroup: { select: 'id,name' },
      percentActionFilters: { select: 'actionId,actionType' },
    },
  },

  group: {
    select: 'id,name,parentProcessGroupId,isActive',
    searchSelect: ['name', 'description'],
    notSelectSearch: 'groups,processes',
    expand: {
      groups: { count: true },
      processes: { count: true },
    },
    orderBy: 'name asc',
  },

  allowed: {
    select: `${select},processGroupId,isFavorite,isBulkRequestCreationEnabled`,
    searchSelect: ['name', 'description'],
    expand: {
      // `id` + `parentProcessGroupId` let the Launchpad rebuild the group
      // hierarchy even when the /process/groups endpoint omits some nodes.
      processGroup: { select: 'id,name,parentProcessGroupId' },
    },
    notSelectSearch: 'process,startMode,isFavorite',
    orderBy: 'name',
  },

  favorite: {
    select: `${select},processGroupId,canManage`,
    searchSelect: ['name', 'description'],
    notSelectSearch: 'process,processGroup,startMode,isFavorite',
    expand: {
      processGroup: { select: 'id,name' },
    },
    orderBy: 'name',
  },
  Portal: {
    select:
      'id,name,description,isActive,shortCode,isPublic,permissionsFiltersLogicalOperator,hideMenuItemHome,hideMenuItemTasks,hideMenuItemRequests',
    searchSelect: ['name', 'description'],
    expand: {
      shortenedUrl: {
        select: 'shortenedUrlCode,redirectUrl',
      },
    },
  },

  PortalDetail: {
    select:
      'id,name,description,isActive,shortCode,template,logoUrl,iconLogoUrl,faviconUrl,mainColor,fontUrl,loginSplashUrl,isPublic,permissionsFiltersLogicalOperator,hideMenuItemHome,hideMenuItemTasks,hideMenuItemRequests,created,updated',
    expand: {
      shortenedUrl: {
        select: 'shortenedUrlCode,redirectUrl',
      },
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
